import React from "react";
import { Typography, Flex, Space, Divider, Button, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import TemplatePreview from "../../../../../components/commonComponents/templates/TemplatePreview";
import { Modal } from "antd";
const { Text } = Typography;

// Utility to parse custom markup
function parseCustomMarkup(text) {
  if (!text) return null;
  // Replace \n with a unique placeholder
  const NEWLINE_PLACEHOLDER = "__NEWLINE__";
  let replaced = text.replace(/\\n/g, NEWLINE_PLACEHOLDER);

  // Handle underline: *_text_*
  replaced = replaced.replace(/\*_([^*]+)_\*/g, "<u>$1</u>");
  // Handle bold: *text*
  replaced = replaced.replace(/\*([^*]+)\*/g, "<b>$1</b>");
  // Handle strikethrough: ~text~
  replaced = replaced.replace(/~([^~]+)~/g, "<s>$1</s>");

  // Split by placeholder and interleave <br />
  const parts = replaced.split(NEWLINE_PLACEHOLDER);
  // Use dangerouslySetInnerHTML for HTML tags
  return parts.map((part, idx) => [
    <span key={idx} dangerouslySetInnerHTML={{ __html: part }} />,
    idx < parts.length - 1 ? <br key={idx + "-br"} /> : null,
  ]);
}

// Example usage inside ListTemplatePreview (replace 'yourText' with your variable)
// {parseCustomMarkup(yourText)}

export default function ListTemplatePreview({
  body,
  header,
  header_type,
  footer,
  language = "english_US",
  template_type,
  template_name,
  template,
  selectTemplate = () => {},
  onClickUseButton = () => {},
}) {
  return (
    <Flex
      className="w-full h-full border-[1px] border-[#E8E8EA] rounded-md bg-white"
      vertical
    >
      <Flex justify="space-between" align="center" className="px-4 py-1">
        <Tooltip title={template_name}>
          <Text
            strong
            className="text-xs overflow-hidden whitespace-nowrap text-ellipsis w-[70%] "
          >
            {template_name}
          </Text>
        </Tooltip>

        <Button
          onClick={() => selectTemplate(template)}
          type="text"
          icon={<EyeOutlined />}
          className="w-full"
        />
      </Flex>

      <Divider className="m-0" />

      <div className="movie-ticket-card__content px-2 py-4 pt-2">
        <Space
          className="bg-[#E7F1EE] px-4 py-4 rounded-md min-h-[240px] max-h-[240px] overflow-y-scroll"
          direction="vertical"
          size="middle"
        >
          {header && RenderPreviewHeader({ type: header_type, header })}
          <Text className="text-xs text-[#2D3036]">
            {parseCustomMarkup(body)}
          </Text>
          <Text className="text-xs text-[#2D3036]" type="secondary">
            {footer}
          </Text>
        </Space>
      </div>

      <Flex justify="space-between" className="px-2 pb-4">
        <Space>
          <Text className="text-xs text-[#616874] rounded-sm px-2 py-1 bg-[#F1F4F6]">
            {template_type}
          </Text>
          <Text className="text-xs text-[#616874] rounded-sm px-2 py-1 bg-[#F1F4F6]">
            {language}
          </Text>
        </Space>

        <Button
          className="text-xs"
          size="small"
          style={{
            backgroundColor: "#05805C",
            color: "#ffffff",
          }}
          onClick={() => onClickUseButton(template)}
        >
          Use
        </Button>
      </Flex>
    </Flex>
  );
}

const RenderPreviewHeader = ({ type, header }) => {
  switch (type) {
    case "IMAGE":
      return (
        <img
          src={header}
          alt=""
          className="w-full max-h-[100px] object-cover"
        />
      );
    case "TEXT":
      return (
        <Text strong className=" text-[#2D3036]">
          {header}
        </Text>
      );
    case "VIDEO":
      return (
        <video
          autoPlay
          muted
          src={header}
          className="w-full max-h-[100px] object-cover"
        />
      );
    case "DOCUMENT":
      return (
        <iframe src={header} className="w-full max-h-[100px] object-cover" />
      );
    default:
      return null;
  }
};
